import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import commonProblem from './views/common-problem'
import exclusiveCustomerService from './views/exclusive-customer-service'
import share from './views/share'

export default [
  {
    path: RoutePathConstants.COMMON_PROBLEM,
    name: 'commonProblem',
    component: commonProblem
  },
  {
    path: RoutePathConstants.EXCLUSIVE_CUSTOMER_SERVICE,
    name: 'exclusiveCustomerService',
    component: exclusiveCustomerService
  },
  {
    path: RoutePathConstants.SHARE,
    name: 'share',
    component: share
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/more-services/routers.js